import axios from "axios"

import { API_URL } from "../../config/appConfig"
import { BASIC_STATUS } from "../../types/_enums"

export const ORG_BASE_URL = `${API_URL}/api/Organizations`

export const getOrganization = (headers: any) => {
  return axios.get(ORG_BASE_URL, { headers })
}

export const patchContactStatus = (organizationId: number, contactId: number, params: any) => {
  return axios.patch(`${ORG_BASE_URL}/${organizationId}/contacts/${contactId}`, {}, { params })
}

export const getOrganizationByID = (organizationPk: number) => {
  return axios.get(`${ORG_BASE_URL}/${organizationPk}`)
}

export const getCompleteContactList = (payload: any, params: any, headers: any) => {
  return axios.post(`${ORG_BASE_URL}/contactList`, payload, { params, headers })
}

export const getOrgDocuments = (organizationPk: number, headers: any) => {
  return axios.get(`${ORG_BASE_URL}/${organizationPk}/organizationDocuments`, { headers })
}

export const downloadOrgDocument = (organizationPk: number, documentId: string, onDownloadProgress: any) => {
  return axios.get(`${ORG_BASE_URL}/${organizationPk}/organizationDocument/${documentId}`, { responseType: "blob", onDownloadProgress })
}

export const putOrganizationDocument = (organizationPk: number, documentId: string, params: any) => {
  return axios.put(`${ORG_BASE_URL}/${organizationPk}/organizationDocuments/${documentId}`, {}, { params })
}

export const putOrganizationIssuer = (organizationPk: number, documentId: string, params: any) => {
  return axios.put(`${ORG_BASE_URL}/${organizationPk}/organizationDocuments/${documentId}`, {}, { params })
}

export const getOrganizationIssuersByOrgId = (organizationPk: number, headers: any) => {
  return axios.get(`${ORG_BASE_URL}/${organizationPk}/Issuers`, { headers })
}

export const getOrganizationContactsByOrgId = (organizationPk: number, headers: any) => {
  return axios.get(`${ORG_BASE_URL}/${organizationPk}/contacts`, { headers })
}

export const getOrganizationClientsByOrgId = (organizationPk: number, headers: any) => {
  return axios.get(`${ORG_BASE_URL}/${organizationPk}/clients`, { headers })
}

export const updateOrganizationByOrgId = (organizationPk: number, payload: any) => {
  return axios.put(`${ORG_BASE_URL}/${organizationPk}`, payload)
}

export const createNewIssuers = (organizationPk: number, payload: any) => {
  return axios.post(`${ORG_BASE_URL}/${organizationPk}/createnewissuers`, payload)
}

export const putContactForOrg = (organizationId: number, contactId: number, payload: any) => {
  return axios.put(`${ORG_BASE_URL}/${organizationId}/contacts/${contactId}`, payload)
}

export const updateOrganizationIssuerById = (organizationPk: number, issuerId: number, payload: any) => {
  return axios.put(`${ORG_BASE_URL}/${organizationPk}/issuers/${issuerId}`, payload)
}

export const patchIssuerStatus = (organizationId: number, issuerId: number, status: BASIC_STATUS) => {
  return axios.patch(`${ORG_BASE_URL}/${organizationId}/issuers/${issuerId}`, {}, { params: { status } })
}
  
export const checkIssuerCodeDuplicate = (organizationId: number, issuerId: number, code: string) => {
  return axios.get(`${ORG_BASE_URL}/${organizationId}/issuers/${issuerId}/isIssuerCodeDuplicate`, { params: { issuerCode: code } })
}

export const patchWorkDayWithhold = (organizationId: number, issuerId: number, exclude: boolean) => {
  return axios.patch(`${ORG_BASE_URL}/${organizationId}/issuers/${issuerId}/excludeFromWorkDay`, {}, { params: { exclude } })
}

export const postOrganization = (payload: any) => {
  const formData = new FormData()
  Object.keys(payload).forEach((key: string) => formData.append(key, payload[key]))
  return axios.post(`${ORG_BASE_URL}`, formData, {
    headers: { "Content-Type": "multipart/form-data" }
  })
}

export const uploadOrgDocuments = (organizationPk: number, docType: any, comment: string, fileInput: File) => {
  const formData = new FormData();
  formData.append('formFile', fileInput);
  return axios.post(`${ORG_BASE_URL}/uploadOrgDocument?organizationId=${organizationPk}&docType=${docType}&comment=${comment}`, formData, {
    headers: { "Content-Type": "multipart/form-data" }
  })
}